export function initVideoLazyLoad() {
  const videos = document.querySelectorAll('.capability-media video');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.play().catch(() => {});
      } else {
        entry.target.pause();
      }
    });
  }, { threshold: 0.25 });

  videos.forEach((vid) => observer.observe(vid));
}
